import s from './Title.module.css';

export const Title = ({ children }: { children: React.ReactNode }) => {
  return <h2 className={s.title}>{children}</h2>;
};
